import { makeStyles } from 'tss-react/mui';

const name = 'SuspendedUserAlert';

export const useSuspendedUserAlertStyles = makeStyles({ name })(theme => ({
  root: {
    alignItems: 'center',

    width: '100%',
    marginBottom: theme.spacing(5),
    padding: theme.spacing(2, 4, 2, 3),

    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(4),
    },
  },
  message: {
    display: 'flex',
    alignItems: 'center',

    margin: 0,
  },
}));
